/* Anillo Customizador — motor de marca blanca.
   Lee su configuración del <script type="application/json"> que va dentro de
   cada contenedor [data-anillo-customizador] y arma todo ahí mismo:
   giro 360°, metal, forma, estilo, talla, frase grabada, precio y pedido por WhatsApp. */
(function () {
  'use strict';

  function slug(s) {
    return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase().replace(/[^a-z0-9.]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function h(tag, attrs, html) {
    var n = document.createElement(tag);
    for (var k in attrs || {}) n.setAttribute(k, attrs[k]);
    if (html != null) n.innerHTML = html;
    return n;
  }

  function init(root, cfg) {
    var N = cfg.imagenes.cuadros || 100;
    var metales = cfg.metales, formas = cfg.formas, estilos = cfg.estilos;
    var centro = parseFloat(cfg.quilatesCentro) || 2;
    var maxFrase = (cfg.grabado && cfg.grabado.max) || 20;
    var params = new URLSearchParams(location.search);

    estilos.forEach(function (e) {
      e.laterales = parseFloat(e.laterales) || 0;
      e.sin = String(e.sinFormas || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      // "MQ=241Q,ASH=241Q": para esas formas se usa la foto de otro modelo muy parecido.
      e.alt = {};
      String(e.alternas || '').split(',').forEach(function (p) {
        var kv = p.split('=');
        if (kv.length === 2 && kv[0].trim() && kv[1].trim()) e.alt[kv[0].trim()] = kv[1].trim();
      });
    });

    function buscar(lista, valor, porDefecto) {
      var v = valor && slug(valor);
      return lista.find(function (x) { return v && (slug(x.nombre) === v || slug(x.corto || '') === v || slug(x.codigo) === v); })
        || lista.find(function (x) { return x.codigo === porDefecto; }) || lista[0];
    }
    function disponible(e, f) { return e.sin.indexOf(f.codigo) === -1; }
    // Si no hay foto de esa combinación, se enseña la forma más parecida como referencia.
    function formaFoto(e, f) {
      if (disponible(e, f)) return f;
      var p = (cfg.formaParecida || {})[f.codigo];
      var parecida = formas.find(function (x) { return x.codigo === p; });
      return parecida && disponible(e, parecida) ? parecida : formas.find(function (x) { return disponible(e, x); });
    }
    // De dónde sale la foto: la combinación exacta, otro modelo parecido en la misma forma, o la forma más parecida.
    function fuente(e, f) {
      if (disponible(e, f)) return { e: e, f: f };
      if (e.alt[f.codigo]) return { e: { codigo: e.alt[f.codigo], sufijo: '' }, f: f, nota: e.notaAlternas || 'de un modelo muy parecido' };
      return { e: e, f: formaFoto(e, f) };
    }

    var st = {
      metal: buscar(metales, params.get('metal'), cfg.inicio.metal),
      forma: buscar(formas, params.get('forma'), cfg.inicio.forma),
      estilo: buscar(estilos, params.get('estilo'), cfg.inicio.estilo),
      talla: '',
      frase: (params.get('frase') || '').slice(0, maxFrase),
      gemas: false, gemaA: null, gemaB: null
    };
    var listaGemas = (cfg.gemasNacimiento && cfg.gemasNacimiento.lista) || [];
    var gemasUrl = (params.get('gemas') || '').split('-');
    if (listaGemas.length && params.get('gemas')) {
      st.gemas = true;
      st.gemaA = listaGemas[parseInt(gemasUrl[0], 10) - 1] || null;
      st.gemaB = listaGemas[parseInt(gemasUrl[1], 10) - 1] || null;
    }
    var tallaUrl = params.get('talla');
    if (tallaUrl && (cfg.tallas.indexOf(tallaUrl) !== -1 || tallaUrl === 'no-se')) st.talla = tallaUrl;
    st.cuando = '';
    var opcionesCuando = (cfg.textos && cfg.textos.cuandoOpciones) || ['Lo antes posible', 'En 1 o 2 meses', 'En 3 meses o más', 'Todavía no sé'];
    function textoTalla() { return st.talla === 'no-se' ? 'no la sé, ayúdame' : (st.talla || 'por definir'); }
    // Joyerías que cotizan por WhatsApp pueden ocultar precios y quilates fijos.
    var conPrecio = cfg.mostrarPrecio !== false, conQuilates = cfg.mostrarQuilates !== false;

    // ---------- Estructura ----------
    root.innerHTML = '';
    root.style.setProperty('--ac-boton', cfg.colorBoton || '#000');
    // Color propio para el botón de ordenar (p. ej. verde para que resalte); si no hay, el de siempre.
    if (cfg.colorOrdenar) { root.style.setProperty('--ac-ordenar', cfg.colorOrdenar); root.classList.add('ac-ordenar-color'); }
    if (cfg.fuentes && cfg.fuentes.texto) root.style.setProperty('--ac-fuente', cfg.fuentes.texto);
    if (cfg.fuentes && cfg.fuentes.titulos) root.style.setProperty('--ac-fuente-titulos', cfg.fuentes.titulos);
    var wrap = h('div', { class: 'ac-wrap' });
    root.appendChild(wrap);

    var visor = h('div', { class: 'ac-visor' });
    var canvas = h('canvas', { class: 'ac-canvas', 'aria-label': 'Arrastra para girar el anillo' });
    var aviso = h('div', { class: 'ac-aviso', hidden: '' });
    var referencia = h('div', { class: 'ac-referencia', hidden: '' });
    visor.appendChild(canvas);
    visor.appendChild(referencia);
    visor.appendChild(aviso);
    if (cfg.logo) {
      var logoImg = h('img', { class: 'ac-logo', src: cfg.logo, alt: cfg.tienda || '' });
      if (cfg.logoInvertir) logoImg.style.filter = 'invert(1)';
      visor.appendChild(logoImg);
    }
    var botonesOro = metales.map(function (m, i) {
      var b = h('button', { type: 'button', class: 'ac-oro', title: m.nombre, style: 'top:' + (10 + i * 50) + 'px;background-color:' + m.color }, m.etiqueta);
      b.addEventListener('click', function () { st.metal = m; actualizar(); });
      visor.appendChild(b);
      return b;
    });
    wrap.appendChild(visor);
    // Letrero fijo abajo del anillo: mucha gente no sabe que se gira arrastrando.
    var tactil = window.matchMedia && window.matchMedia('(hover: none)').matches;
    wrap.appendChild(h('p', { class: 'ac-pista' }, (cfg.textos && cfg.textos.girar) || (tactil ? 'Desliza para girar' : 'Arrastra para girar')));

    function carrusel(titulo, lista, clase, tamano, alElegir) {
      wrap.appendChild(h('h3', { class: 'ac-titulo' }, titulo));
      var cont = h('div', { class: 'ac-carrusel' });
      var items = lista.map(function (x) {
        var it = h('div', { class: 'ac-item ' + clase, role: 'button', tabindex: '0', style: 'background-size:' + tamano });
        if (x.img) it.style.backgroundImage = 'url("' + x.img + '")';
        it.appendChild(h('div', { class: 'ac-nombre' }, x.nombre));
        function elegir() { alElegir(x); }
        it.addEventListener('click', elegir);
        it.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); elegir(); } });
        cont.appendChild(it);
        return it;
      });
      wrap.appendChild(cont);
      return { cont: cont, items: items };
    }

    var carForma = carrusel(cfg.textos.tituloDiamante, formas, 'ac-gris', '120%', function (f) { st.forma = f; actualizar(); });
    var carEstilo = carrusel(cfg.textos.tituloEstilo, estilos, '', '170%', function (e) { st.estilo = e; actualizar(); });

    var compra = h('div', { class: 'ac-compra' });
    var talla = h('select', { class: 'ac-talla', 'aria-label': 'Talla' });
    talla.appendChild(h('option', { value: '' }, cfg.textos.elegirTalla || 'Elige tu talla'));
    cfg.tallas.forEach(function (t) { talla.appendChild(h('option', { value: t }, t)); });
    talla.appendChild(h('option', { value: 'no-se' }, cfg.textos.noSeTalla || 'No sé su talla'));
    talla.value = st.talla;
    talla.addEventListener('change', function () { st.talla = talla.value; actualizar(); });
    compra.appendChild(talla);
    // Para cuándo lo necesita: le dice a la joyería qué tan listo está para comprar.
    var cuando = h('select', { class: 'ac-talla ac-cuando', 'aria-label': 'Para cuándo lo necesitas' });
    cuando.appendChild(h('option', { value: '' }, cfg.textos.tituloCuando || '¿Para cuándo lo necesitas?'));
    opcionesCuando.forEach(function (o) { cuando.appendChild(h('option', { value: o }, o)); });
    cuando.addEventListener('change', function () { st.cuando = cuando.value; });
    // preguntarCuando: false quita "¿Para cuándo lo necesitas?"
    if (cfg.preguntarCuando !== false) compra.appendChild(cuando);

    // Frase: se escribe directo sobre la banda de oro (la banda es el campo de texto).
    var banda, contador, puntoA, puntoB;
    if (cfg.grabado !== false) {
      var g = cfg.grabado || {};
      var caja = h('div', { class: 'ac-grabado' });
      var idFrase = 'ac-frase-' + Math.random().toString(36).slice(2, 8);
      caja.appendChild(h('label', { class: 'ac-grabado-titulo', for: idFrase }, g.titulo || 'Escribe tu frase especial'));
      banda = h('div', { class: 'ac-banda' });
      puntoA = h('span', { class: 'ac-gema-punto', hidden: '' });
      puntoB = h('span', { class: 'ac-gema-punto', hidden: '' });
      var input = h('input', { id: idFrase, class: 'ac-frase', type: 'text', maxlength: String(maxFrase), placeholder: g.ejemplo || 'Ej. Te amo, mi amor', autocomplete: 'off', spellcheck: 'false' });
      input.value = st.frase;
      input.addEventListener('input', function () { st.frase = input.value.slice(0, maxFrase); pintarBanda(); });
      banda.addEventListener('click', function () { input.focus(); });
      banda.appendChild(puntoA);
      banda.appendChild(input);
      banda.appendChild(puntoB);
      caja.appendChild(banda);
      var nota = h('div', { class: 'ac-grabado-nota' }, (g.nota || 'Va grabada por dentro del anillo') + ' · ');
      contador = h('span');
      nota.appendChild(contador);
      caja.appendChild(nota);
      compra.appendChild(caja);
    }

    // Gemas de nacimiento (extra con precio): la tuya y la de tu pareja.
    var gn = cfg.gemasNacimiento;
    if (gn && gn.lista && gn.lista.length) {
      var cg = h('div', { class: 'ac-gemas' });
      var lab = h('label', { class: 'ac-gemas-check' });
      var chk = h('input', { type: 'checkbox' });
      lab.appendChild(chk);
      lab.appendChild(h('span', {}, (gn.titulo || 'Agregar gemas de nacimiento') + (conPrecio ? ' <strong>+' + dinero(parseFloat(gn.precio) || 0) + '</strong>' : '')));
      cg.appendChild(lab);
      var meses = h('div', { class: 'ac-meses', hidden: '' });
      // La nota (una por tu mes y otra por el de tu pareja) solo aparece al marcar las gemas, junto a los meses.
      if (gn.nota) meses.appendChild(h('p', { class: 'ac-gemas-nota' }, gn.nota));
      var selector = function (etiqueta, valor) {
        var w = h('label', { class: 'ac-mes' });
        w.appendChild(h('span', {}, etiqueta));
        var s = h('select');
        s.appendChild(h('option', { value: '' }, 'Elige el mes'));
        gn.lista.forEach(function (x, i) { s.appendChild(h('option', { value: String(i) }, x.mes + ' · ' + x.gema)); });
        if (valor) s.value = String(gn.lista.indexOf(valor));
        s.addEventListener('change', function () { actualizar(); });
        w.appendChild(s);
        meses.appendChild(w);
        return s;
      };
      var selA = selector(gn.tu || 'Tu mes', st.gemaA), selB = selector(gn.pareja || 'Mes de tu pareja', st.gemaB);
      chk.checked = st.gemas;
      meses.hidden = !st.gemas;
      chk.addEventListener('change', function () { st.gemas = chk.checked; meses.hidden = !chk.checked; actualizar(); });
      var leerGemas = function () {
        st.gemaA = selA.value === '' ? null : gn.lista[+selA.value];
        st.gemaB = selB.value === '' ? null : gn.lista[+selB.value];
      };
      cg.appendChild(meses);
      compra.appendChild(cg);
    }

    var specs = h('p', { class: 'ac-specs' });
    compra.appendChild(specs);
    var ordenar = h('button', { type: 'button', class: 'ac-ordenar' });
    ordenar.addEventListener('click', pedir);
    compra.appendChild(ordenar);
    if (cfg.textos.notaBoton) compra.appendChild(h('p', { class: 'ac-nota' }, cfg.textos.notaBoton));
    // Mándaselo a alguien: casi nadie compra un anillo de compromiso sin pedir opinión.
    var compartir = h('button', { type: 'button', class: 'ac-compartir' }, cfg.textos.compartir || 'Mándaselo a alguien');
    compartir.addEventListener('click', function () {
      var link = /^https?:/.test(location.protocol) ? linkDiseno() : '';
      var texto = (cfg.textos.textoCompartir || 'Mira el anillo que armé') + ': ' + st.estilo.nombre + ' · ' + st.forma.nombre + ' · ' + st.metal.nombre + (link ? '\n' + link : '');
      evento('compartido');
      if (navigator.share) { navigator.share({ title: cfg.tienda || '', text: texto }).catch(function () {}); return; }
      var w = window.open('https://wa.me/?text=' + encodeURIComponent(texto), '_blank');
      if (!w) location.href = 'https://wa.me/?text=' + encodeURIComponent(texto);
    });
    if (!cfg.compartirUnido) compra.appendChild(compartir);

    // Súbelo a tus redes: arma una imagen vertical (1080×1920) con el anillo, lista para historias.
    var redes = h('button', { type: 'button', class: 'ac-compartir ac-redes' }, cfg.textos.redes || 'Súbelo a tus redes');
    function descargar(archivo) {
      var a = document.createElement('a');
      a.href = URL.createObjectURL(archivo);
      a.download = archivo.name;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
      avisar(cfg.textos.redesGuardada || 'Imagen guardada. Súbela a tus historias.');
    }
    redes.addEventListener('click', function () {
      redes.disabled = true;
      tarjetaRedes().then(function (archivo) {
        evento('redes');
        var texto = (cfg.textos.textoRedes || 'Así sería mi anillo') + (cfg.tienda ? ' · ' + cfg.tienda : '');
        if (navigator.canShare && navigator.canShare({ files: [archivo] })) {
          return navigator.share({ files: [archivo], text: texto }).catch(function (e) { if (!e || e.name !== 'AbortError') descargar(archivo); });
        }
        descargar(archivo);
      }).catch(function () { avisar('No se pudo crear la imagen. Intenta de nuevo.'); })
        .then(function () { redes.disabled = false; });
    });
    if (!cfg.compartirUnido) compra.appendChild(redes);

    // Opción compartirUnido: un solo botón para las dos cosas. Arma la imagen para historias y la manda junto con el link
    // del diseño; el teléfono deja escoger WhatsApp (mandárselo a alguien), Instagram (historias), etc.
    if (cfg.compartirUnido) {
      var unido = h('button', { type: 'button', class: 'ac-compartir ac-redes' }, cfg.textos.compartirUnido || 'Súbelo a tus redes o mándaselo a alguien');
      unido.addEventListener('click', function () {
        unido.disabled = true;
        var link = /^https?:/.test(location.protocol) ? linkDiseno() : '';
        var texto = (cfg.textos.textoCompartir || 'Mira el anillo que armé') + ': ' + st.estilo.nombre + ' · ' + st.forma.nombre + ' · ' + st.metal.nombre + (link ? '\n' + link : '');
        var soloTexto = function () {
          if (navigator.share) return navigator.share({ title: cfg.tienda || '', text: texto }).catch(function () {});
          var w = window.open('https://wa.me/?text=' + encodeURIComponent(texto), '_blank');
          if (!w) location.href = 'https://wa.me/?text=' + encodeURIComponent(texto);
        };
        tarjetaRedes().then(function (archivo) {
          evento('compartido');
          if (navigator.canShare && navigator.canShare({ files: [archivo] })) {
            return navigator.share({ files: [archivo], text: texto }).catch(function (e) { if (!e || e.name !== 'AbortError') { descargar(archivo); soloTexto(); } });
          }
          descargar(archivo);
          return soloTexto();
        }).catch(function () { evento('compartido'); return soloTexto(); })
          .then(function () { unido.disabled = false; });
      });
      compra.appendChild(unido);
    }

    function cargarImagen(src) {
      return new Promise(function (ok, mal) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () { ok(im); };
        im.onerror = mal;
        im.src = src;
      });
    }
    function redondeado(c, x, y, w, alto, r) {
      c.beginPath(); c.moveTo(x + r, y);
      c.arcTo(x + w, y, x + w, y + alto, r); c.arcTo(x + w, y + alto, x, y + alto, r);
      c.arcTo(x, y + alto, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath();
    }
    function tarjetaRedes() {
      var W = 1080, H = 1920, cv = document.createElement('canvas');
      cv.width = W; cv.height = H;
      var c = cv.getContext('2d');
      var r = cfg.redes || {};
      var fondo = r.fondo || '#f4f2ee', tinta = r.tinta || '#111111', tenue = r.tenue || 'rgba(17,17,17,.62)';
      var tit = (cfg.fuentes && cfg.fuentes.titulos) || 'sans-serif', txt = (cfg.fuentes && cfg.fuentes.texto) || 'sans-serif';
      var src = fuente(st.estilo, st.forma);
      var foto = urlFoto(base, src.e, src.f, st.metal, cuadro);
      if (/cdn\.shopify\.com/.test(foto)) foto += '?width=1000';
      var letras = document.fonts && document.fonts.load ? Promise.all([document.fonts.load('600 92px ' + tit), document.fonts.load('400 44px ' + txt)]).catch(function () {}) : Promise.resolve();
      return Promise.all([cargarImagen(foto), cfg.logo ? cargarImagen(cfg.logo).catch(function () { return null; }) : Promise.resolve(null), letras]).then(function (x) {
        var anillo = x[0], logo = x[1];
        c.fillStyle = fondo; c.fillRect(0, 0, W, H);
        c.textAlign = 'center';
        if (logo) {
          var lh = 120, lw = logo.naturalWidth * lh / logo.naturalHeight;
          if (lw > 520) { lw = 520; lh = logo.naturalHeight * lw / logo.naturalWidth; }
          c.save(); if (r.logoInvertir) c.filter = 'invert(1)';
          c.drawImage(logo, (W - lw) / 2, 230 - lh / 2, lw, lh); c.restore();
        } else {
          c.fillStyle = tinta; c.font = '600 64px ' + tit;
          c.fillText(String(cfg.tienda || '').toUpperCase(), W / 2, 250);
        }
        var cx = 90, cy = 380, cw = W - 180, ch = cw;
        c.fillStyle = '#ffffff'; redondeado(c, cx, cy, cw, ch, 36); c.fill();
        var s = Math.min(cw / anillo.naturalWidth, ch / anillo.naturalHeight) * 1.3;
        var dw = anillo.naturalWidth * s, dh = anillo.naturalHeight * s;
        c.save(); redondeado(c, cx, cy, cw, ch, 36); c.clip();
        c.drawImage(anillo, cx + (cw - dw) / 2, cy + (ch - dh) / 2, dw, dh); c.restore();
        c.fillStyle = tinta; c.font = '600 96px ' + tit;
        c.fillText(String(cfg.textos.textoRedes || 'Así sería mi anillo').toUpperCase(), W / 2, cy + ch + 160);
        c.fillStyle = tenue; c.font = '400 44px ' + txt;
        c.fillText(st.estilo.nombre + ' · ' + st.forma.nombre + ' · ' + st.metal.nombre, W / 2, cy + ch + 235);
        if (st.frase.trim()) {
          var bw = 760, bh = 100, bx = (W - bw) / 2, by = cy + ch + 300;
          var col = st.metal.banda || ['#b8913a', '#f6e2a6', '#b08530'];
          var gr = c.createLinearGradient(0, by, 0, by + bh);
          gr.addColorStop(0, col[0]); gr.addColorStop(0.45, col[1]); gr.addColorStop(1, col[2]);
          c.fillStyle = gr; redondeado(c, bx, by, bw, bh, bh / 2); c.fill();
          c.fillStyle = 'rgba(0,0,0,.62)'; c.font = 'italic 48px Georgia, serif';
          c.fillText(st.frase.trim(), W / 2, by + 66);
        }
        c.fillStyle = tenue; c.font = '400 38px ' + txt;
        c.fillText(r.pie || ('Diséñalo tú en ' + (r.dominio || location.hostname || '')), W / 2, H - 150);
        return new Promise(function (ok, mal) {
          cv.toBlob(function (b) { b ? ok(new File([b], 'mi-anillo.jpg', { type: 'image/jpeg' })) : mal(new Error('canvas')); }, 'image/jpeg', 0.92);
        });
      });
    }
    wrap.appendChild(compra);

    var vMetal = h('strong'), vQuilates = h('strong');
    if (cfg.mostrarDetalles) {
      var detalles = h('div', { class: 'ac-tarjeta' });
      detalles.appendChild(h('h2', {}, cfg.textos.tituloDetalles || 'Detalles de tu anillo de diamante'));
      var fila = function (etiqueta, valor) {
        var p = h('p', { class: 'ac-fila' });
        p.appendChild(h('strong', {}, etiqueta + ':'));
        p.appendChild(document.createTextNode(' '));
        p.appendChild(typeof valor === 'string' ? document.createTextNode(valor) : valor);
        detalles.appendChild(p);
      };
      fila('Metal', vMetal);
      fila('Quilates', vQuilates);
      (cfg.detalles || []).forEach(function (d) { if (d.valor) fila(d.etiqueta, d.valor); });
      wrap.appendChild(detalles);
      if (cfg.confianza && (cfg.confianza.titulo || (cfg.confianza.parrafos || []).length)) {
        var conf = h('div', { class: 'ac-tarjeta' });
        if (cfg.confianza.titulo) conf.appendChild(h('h2', {}, cfg.confianza.titulo));
        cfg.confianza.parrafos.forEach(function (t) { if (t) conf.appendChild(h('p', { class: 'ac-fila' }, t)); });
        wrap.appendChild(conf);
      }
    }

    // ---------- Precio y mensaje ----------
    function quilates(e) { return centro + e.laterales; }
    function precio() {
      var m = 1 + (parseFloat(st.metal.ajuste) || 0) / 100;
      var f = 1 + (parseFloat(st.forma.ajuste) || 0) / 100;
      var extraTalla = (cfg.precio.extraTalla || {})[st.talla] || 0;
      return Math.ceil(quilates(st.estilo) * cfg.precio.porQuilate * m * f) + extraTalla + precioGemas();
    }
    function precioGemas() { return st.gemas ? (parseFloat(cfg.gemasNacimiento.precio) || 0) : 0; }
    function nombreGema(x) { return x ? x.gema + ' (' + x.mes.toLowerCase() + ')' : 'por definir'; }
    function dinero(n) { return '$' + n.toLocaleString(cfg.locale || 'es-MX'); }
    function textoLaterales(e) { return e.laterales ? e.laterales + ' ct en piedras laterales' : 'sin piedras laterales'; }

    function linkDiseno() {
      var q = new URLSearchParams({ metal: slug(st.metal.corto || st.metal.nombre), forma: slug(st.forma.nombre), estilo: slug(st.estilo.nombre) });
      if (st.talla) q.set('talla', st.talla);
      if (st.frase) q.set('frase', st.frase);
      if (st.gemas) q.set('gemas', (listaGemas.indexOf(st.gemaA) + 1) + '-' + (listaGemas.indexOf(st.gemaB) + 1));
      return location.origin + location.pathname + '?' + q.toString();
    }

    // ---------- Leads ----------
    // modo "directo": WhatsApp de la joyería · "central": WhatsApp de la central (ella lo pasa a la joyería)
    // · "ambos": WhatsApp de la joyería y copia a la central. Si hay "registro", cada lead también se guarda ahí.
    var leads = cfg.leads || {};
    var servidor = String(leads.servidor || '').replace(/\/+$/, '');
    if (servidor && leads.cliente) {
      // La central decide a qué WhatsApp se abre y si la joyería está activa.
      fetch(servidor + '/v1/config/' + encodeURIComponent(leads.cliente)).then(function (r) { return r.json(); }).then(function (c) {
        if (c.activo === false) { root.innerHTML = ''; return; }
        if (c.abrir) leads.abrir = c.abrir;
        if (c.prefijo) leads.prefijo = c.prefijo;
        if (c.modo) leads.modo = c.modo;
      }).catch(function () {});
    }
    // Cuenta visitas y acciones en la central (sin datos personales) para las estadísticas del panel.
    function evento(tipo) {
      if (!servidor || !leads.cliente) return;
      try {
        fetch(servidor + '/v1/evento', { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ cliente: leads.cliente, tipo: tipo, origen: params.get('utm_source') || '' }) });
      } catch (e) {}
    }
    (function () {
      var ya = false;
      try { ya = sessionStorage.getItem('ac-vista') === '1'; sessionStorage.setItem('ac-vista', '1'); } catch (e) {}
      if (!ya) evento('vista');
    })();
    function nuevoFolio() {
      return (leads.prefijo || 'AN') + '-' + (Date.now().toString(36) + Math.random().toString(36).slice(2, 4)).toUpperCase().slice(-7);
    }
    function registrar(folio, texto) {
      var destino = leads.registro || (servidor ? servidor + '/v1/lead' : '');
      if (!destino) return;
      var src = fuente(st.estilo, st.forma);
      var datos = {
        folio: folio, cliente: leads.cliente || '', tienda: cfg.tienda || '', modo: leads.modo || 'directo',
        metal: st.metal.nombre, forma: st.forma.nombre, estilo: st.estilo.nombre,
        quilates: conQuilates ? centro + ' ct + ' + st.estilo.laterales + ' ct laterales' : '', talla: textoTalla(), cuando: st.cuando,
        frase: st.frase.trim(), gemas: st.gemas ? nombreGema(st.gemaA) + ' y ' + nombreGema(st.gemaB) : '',
        precio: conPrecio ? precio() : null, referencia: src.f !== st.forma ? 'en ' + src.f.nombre : (src.nota || ''),
        origen: params.get('utm_source') || '', link: /^https?:/.test(location.protocol) ? linkDiseno() : '',
        foto: fotoDirecta(), pagina: location.href, mensaje: texto
      };
      var body = JSON.stringify(datos);
      try {
        fetch(destino, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: body });
      } catch (e) {
        try { navigator.sendBeacon(destino, new Blob([body], { type: 'text/plain' })); } catch (e2) {}
      }
    }

    // Foto del anillo (vista de frente, en chico) para que se vea en el chat y en la central.
    function fotoDirecta() {
      var src = fuente(st.estilo, st.forma);
      var u = urlFoto(base, src.e, src.f, st.metal, 0);
      return u + (/cdn\.shopify\.com/.test(u) ? '?width=' + ((cfg.imagenes && cfg.imagenes.anchoFoto) || 500) : '');
    }
    // Con central: link propio con vista previa (no enseña de dónde vienen las fotos). Sin central: la foto directa.
    function fotoUrl() {
      if (!servidor || !leads.cliente) return fotoDirecta();
      var src = fuente(st.estilo, st.forma);
      var nombre = urlFoto('', src.e, src.f, st.metal, 0).replace(/\.jpg$/, '');
      var titulo = st.estilo.nombre + ' · ' + st.forma.nombre + ' · ' + st.metal.nombre;
      return servidor + '/r/' + encodeURIComponent(leads.cliente) + '/' + nombre + '?t=' + encodeURIComponent(titulo);
    }

    function mensaje(folio) {
      var t = cfg.textos, src = fuente(st.estilo, st.forma);
      var lineas = [
        t.saludo,
        fotoUrl(),
        '- Metal: ' + st.metal.nombre,
        '- Diamante central: ' + st.forma.nombre + (conQuilates ? ', ' + centro + ' ct' : ''),
        '- Estilo: ' + st.estilo.nombre + (conQuilates ? ' (' + textoLaterales(st.estilo) + ')' : ''),
        '- Talla: ' + textoTalla()
      ];
      if (st.cuando) lineas.push('- Para cuándo: ' + st.cuando);
      if (st.frase.trim()) lineas.push('- Grabado: "' + st.frase.trim() + '"');
      if (st.gemas) lineas.push('- Gemas de nacimiento: ' + nombreGema(st.gemaA) + ' y ' + nombreGema(st.gemaB) + (conPrecio ? ' (+' + dinero(precioGemas()) + ')' : ''));
      if (conPrecio) lineas.push('- Precio aprox.: ' + dinero(precio()));
      if (src.f !== st.forma) lineas.push('(Vi la foto de referencia en ' + src.f.nombre + ')');
      else if (src.nota) lineas.push('(Vi una foto de referencia ' + src.nota + ')');
      lineas.push('Código: ' + [st.estilo.nombre, st.forma.nombre, st.metal.corto || st.metal.nombre].map(slug).join('-').toUpperCase() + (st.talla ? '-' + st.talla : ''));
      if (folio) lineas.push('Folio: ' + folio);
      var origen = params.get('utm_source');
      if (origen) lineas.push('Vengo de: ' + origen);
      if (/^https?:/.test(location.protocol)) lineas.push('Mi diseño: ' + linkDiseno());
      if (t.cierre) lineas.push(t.cierre);
      return lineas.join('\n');
    }

    function pedir() {
      var folio = nuevoFolio(), texto = mensaje(folio);
      var numero = leads.abrir || (leads.modo === 'central' && leads.whatsappCentral ? leads.whatsappCentral : cfg.whatsapp);
      var url = 'https://wa.me/' + String(numero).replace(/\D/g, '') + '?text=' + encodeURIComponent(texto);
      registrar(folio, texto);
      try { if (window.fbq) window.fbq('track', 'Lead'); } catch (e) {}
      try { if (window.ttq) window.ttq.track('Contact'); } catch (e) {}
      root.dispatchEvent(new CustomEvent('anillo:pedido', { bubbles: true, detail: { folio: folio, mensaje: texto, precio: precio() } }));
      var w = window.open(url, '_blank');
      if (!w) location.href = url;
    }

    var timerAviso;
    function avisar(texto) {
      aviso.textContent = texto;
      aviso.hidden = false;
      clearTimeout(timerAviso);
      timerAviso = setTimeout(function () { aviso.hidden = true; }, 3500);
    }

    function pintarBanda() {
      if (!banda) return;
      var c = st.metal.banda || ['#b8913a', '#f6e2a6', '#b8913a'];
      banda.style.background = 'linear-gradient(180deg,' + c[0] + ' 0%,' + c[1] + ' 45%,' + c[2] + ' 100%)';
      contador.textContent = st.frase.length + '/' + maxFrase;
      [[puntoA, st.gemaA], [puntoB, st.gemaB]].forEach(function (p) {
        p[0].hidden = !st.gemas;
        p[0].classList.toggle('ac-sin-gema', !p[1]);
        p[0].style.background = p[1] ? 'radial-gradient(circle at 35% 30%, rgba(255,255,255,.95) 0 14%, ' + p[1].color + ' 52%)' : '';
        p[0].title = p[1] ? p[1].gema : '';
      });
    }

    // ---------- Fotos: caché y cola de descarga ----------
    var cache = new Map(), cola = [], activas = 0, MAX_ACTIVAS = 8;
    function urlFoto(base, e, f, m, i) {
      return base + cfg.imagenes.patron
        .replace('{estilo}', e.codigo).replace('{forma}', f.codigo).replace('{metal}', m.codigo)
        .replace('{sufijo}', e.sufijo || '').replace('{cuadro}', i);
    }
    function lista(img) { return img && img.complete && img.naturalWidth > 0; }
    function foto(url, alCargar, prioridad) {
      var img = cache.get(url);
      if (!img) {
        img = new Image();
        img.decoding = 'async';
        if (prioridad) img.fetchPriority = prioridad;
        cache.set(url, img);
        img.src = url;
      }
      if (alCargar) {
        if (lista(img)) alCargar(img);
        else img.addEventListener('load', function () { alCargar(img); }, { once: true });
      }
      return img;
    }
    function bombear() {
      while (activas < MAX_ACTIVAS && cola.length) {
        var u = cola.shift();
        if (cache.has(u)) continue;
        activas++;
        var img = foto(u, null, frames.indexOf(u) > -1 ? 'high' : 'low');
        var fin = function () { activas--; programarDibujo(); bombear(); };
        img.addEventListener('load', fin, { once: true });
        img.addEventListener('error', fin, { once: true });
      }
    }

    // ---------- Giro 360° ----------
    var ctx = canvas.getContext('2d');
    var cuadro = 0, frames = [], ultima = null, turno = 0, base = cfg.imagenes.base;
    var flecha = new Image(), flechaLista = false;
    flecha.onload = function () { flechaLista = true; programarDibujo(); };
    if (cfg.imagenes.flecha) flecha.src = cfg.imagenes.flecha;

    var pendiente = false;
    function programarDibujo() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () { pendiente = false; dibujar(); });
    }

    function dibujar() {
      var esc = window.devicePixelRatio || 1;
      var r = canvas.getBoundingClientRect();
      if (!r.width) return;
      var W = Math.round(r.width * esc), H = Math.round(r.height * esc);
      if (canvas.width !== W || canvas.height !== H) { canvas.width = W; canvas.height = H; }
      var img = null;
      for (var k = 0; !img && k < N; k++) {
        var cand = cache.get(frames[(cuadro - k + N) % N]);
        if (lista(cand)) img = cand;
      }
      img = img || ultima;
      if (!img) return;
      ultima = img;
      ctx.setTransform(esc, 0, 0, esc, 0, 0);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, r.width, r.height);
      var zoom = cfg.imagenes.zoom || 1.3;
      var s = Math.min(r.width / img.naturalWidth, r.height / img.naturalHeight, 1) * zoom;
      var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
      ctx.drawImage(img, (r.width - dw) / 2, (r.height - dh) / 2, dw, dh);
      if (flechaLista) {
        var fw = r.width * 0.6, fh = r.height * 0.1;
        ctx.drawImage(flecha, (r.width - fw) / 2, (r.height - fh) / 1.1, fw, fh);
      }
    }

    // Vecinos: el mismo ángulo en las combinaciones a un toque de distancia, para que el cambio sea inmediato.
    function vecinos(i) {
      var f = st.forma, m = st.metal, us = [];
      function add(src, metal) { us.push(urlFoto(base, src.e, src.f, metal, i)); }
      estilos.forEach(function (x) { add(fuente(x, f), m); });
      formas.forEach(function (x) { add(fuente(st.estilo, x), m); });
      metales.forEach(function (x) { add(fuente(st.estilo, f), x); });
      return us;
    }

    function cargarGiro() {
      var t = ++turno, src = fuente(st.estilo, st.forma), e = src.e, f = src.f, m = st.metal;
      // Respaldo: una o varias carpetas separadas por coma (se prueban en orden si la principal falla).
      var bases = [cfg.imagenes.base].concat(String(cfg.imagenes.respaldo || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean));
      function probar(b) {
        var bs = bases[b], i0 = cuadro, primera = urlFoto(bs, e, f, m, i0);
        var img = foto(primera, null, 'high');
        function ok() {
          if (t !== turno) return;
          base = bs;
          frames = [];
          for (var i = 0; i < N; i++) frames.push(urlFoto(bs, e, f, m, i));
          programarDibujo();
          // Orden: todo el giro (empezando por los ángulos cercanos) y después los vecinos;
          // las miniaturas de los estilos esperan a que ya se vea el anillo.
          var orden = [];
          for (var d = 1; d < N; d++) orden.push(frames[(i0 + (d % 2 ? (d + 1) / 2 : -d / 2) + N) % N]);
          cola = orden.concat(vecinos(i0));
          bombear();
          if (!anilloVisto) { anilloVisto = true; pintarMinis(); }
        }
        if (lista(img)) return ok();
        img.addEventListener('load', ok, { once: true });
        img.addEventListener('error', function () {
          if (t !== turno) return;
          cache.delete(primera);
          if (b + 1 < bases.length) probar(b + 1);
          else avisar('No pudimos cargar esta foto. Prueba otra forma o estilo.');
        }, { once: true });
      }
      probar(0);
      if (cache.size > 2500) cache.forEach(function (v, k) { if (frames.indexOf(k) === -1) cache.delete(k); });
    }

    var arrastrando = false, ultimoX = null, acumulado = 0, sensibilidad = 10;
    function mover(dx) {
      acumulado += dx;
      var pasos = Math.trunc(acumulado / sensibilidad);
      if (pasos !== 0) {
        cuadro = ((cuadro - pasos) % N + N) % N;
        acumulado -= pasos * sensibilidad;
        programarDibujo();
      }
    }
    function soltar() {
      if (arrastrando) { cola = vecinos(cuadro).concat(cola); bombear(); }
      arrastrando = false; ultimoX = null; acumulado = 0;
    }
    // Picar las flechitas (franja de abajo del anillo) gira un octavo de vuelta hacia ese lado, con un giro corto.
    var inicio = null, animando = 0;
    function enFlecha(x, y) {
      var r = canvas.getBoundingClientRect();
      var rx = (x - r.left) / r.width, ry = (y - r.top) / r.height;
      if (ry < 0.75 || ry > 1 || rx < 0.15 || rx > 0.85) return 0;
      return rx < 0.5 ? 1 : -1; // ◀ = como arrastrar a la izquierda; ▶ = a la derecha
    }
    function girarPasos(n) {
      var dir = n > 0 ? 1 : -1, faltan = Math.abs(n), t = ++animando;
      (function paso() {
        if (t !== animando) return;
        cuadro = ((cuadro + dir) % N + N) % N;
        dibujar();
        if (--faltan > 0) requestAnimationFrame(paso);
        else { cola = vecinos(cuadro).concat(cola); bombear(); }
      })();
    }
    function empezar(x, y) { animando++; arrastrando = true; ultimoX = x; inicio = { x: x, y: y, t: Date.now() }; }
    function terminar(x, y) {
      if (arrastrando && inicio && x != null && Math.abs(x - inicio.x) < 8 && Math.abs(y - inicio.y) < 8 && Date.now() - inicio.t < 500) {
        var d = enFlecha(x, y);
        if (d) girarPasos(d * Math.round(N / 8));
      }
      inicio = null;
      soltar();
    }
    canvas.addEventListener('touchstart', function (ev) { ev.preventDefault(); empezar(ev.touches[0].clientX, ev.touches[0].clientY); }, { passive: false });
    canvas.addEventListener('touchmove', function (ev) { ev.preventDefault(); if (!arrastrando) return; var x = ev.touches[0].clientX; mover(x - ultimoX); ultimoX = x; }, { passive: false });
    canvas.addEventListener('touchend', function (ev) { var p = ev.changedTouches && ev.changedTouches[0]; terminar(p ? p.clientX : null, p ? p.clientY : null); });
    canvas.addEventListener('mousedown', function (ev) { ev.preventDefault(); empezar(ev.clientX, ev.clientY); });
    canvas.addEventListener('mousemove', function (ev) { if (!arrastrando) canvas.style.cursor = enFlecha(ev.clientX, ev.clientY) ? 'pointer' : ''; });
    window.addEventListener('mousemove', function (ev) { if (!arrastrando) return; mover(ev.clientX - ultimoX); ultimoX = ev.clientX; });
    window.addEventListener('mouseup', function (ev) { terminar(ev.clientX, ev.clientY); });

    // Burbujas flotantes de la tienda (p. ej. un botón de WhatsApp) que tapan los botones del diseñador:
    // se esconden solo mientras el diseñador está en pantalla (el diseñador ya tiene su propio botón de WhatsApp).
    if (cfg.ocultarFlotantes && 'IntersectionObserver' in window) {
      var tapar = document.createElement('style');
      document.head.appendChild(tapar);
      new IntersectionObserver(function (es) {
        tapar.textContent = es[0].isIntersecting ? cfg.ocultarFlotantes + '{display:none!important}' : '';
      }, { rootMargin: '-10% 0px -10% 0px' }).observe(root);
    }
    window.addEventListener('resize', programarDibujo);
    if ('ResizeObserver' in window) new ResizeObserver(programarDibujo).observe(canvas);

    // ---------- Pintar selección ----------
    var comboAnterior = '';
    var mini = cfg.imagenes.miniatura || { cuadro: 95 };
    function centrar(cont, item) {
      cont.scrollTo({ left: item.offsetLeft - (cont.clientWidth - item.offsetWidth) / 2, behavior: comboAnterior ? 'smooth' : 'auto' });
    }
    // Las miniaturas de los estilos se piden hasta que ya se ve el anillo (para no quitarle velocidad al giro).
    var anilloVisto = false;
    function pintarMinis() {
      if (!anilloVisto) return;
      carEstilo.items.forEach(function (it, i) {
        var x = estilos[i], sx = fuente(x, st.forma);
        var u = x.miniatura || urlFoto(base, sx.e, sx.f, st.metal, mini.cuadro);
        if (it.dataset.foto !== u) { it.dataset.foto = u; it.style.backgroundImage = 'url("' + u + '")'; }
      });
    }
    function actualizar() {
      var e = st.estilo, f = st.forma, src = fuente(e, f);
      botonesOro.forEach(function (b, i) { b.classList.toggle('ac-activo', metales[i] === st.metal); });
      carForma.items.forEach(function (it, i) { it.classList.toggle('ac-activo', formas[i] === f); });
      carEstilo.items.forEach(function (it, i) { it.classList.toggle('ac-activo', estilos[i] === e); });
      pintarMinis();
      if (src.f !== f || src.nota) {
        // Primero que sí se hace; luego que lo único distinto es la foto.
        referencia.innerHTML = 'Sí lo hacemos: ' + e.nombre + ' en ' + f.nombre + '<br>Solo la foto es de referencia (' + (src.nota || 'forma ' + src.f.nombre) + ')';
        referencia.hidden = false;
      } else referencia.hidden = true;
      if (leerGemas) leerGemas();
      var partes = [];
      if (conQuilates) partes.push('Diamante central de ' + centro + ' ct', textoLaterales(e));
      if (conPrecio && st.gemas) partes.push('gemas de nacimiento +' + dinero(precioGemas()));
      // Cada dato en su etiqueta (en vez de una línea larga de texto)
      specs.innerHTML = partes.map(function (p) { return '<span class="ac-chip">' + p + '</span>'; }).join('');
      specs.hidden = !partes.length;
      ordenar.innerHTML = conPrecio ? (cfg.textos.boton || 'ORDENAR') + ' • ' + dinero(precio()) + ' <small>*Aprox</small>' : (cfg.textos.botonCotizar || 'Cotizar por WhatsApp');
      vMetal.textContent = st.metal.largo || st.metal.nombre;
      vQuilates.textContent = quilates(e) + ' TCW~';
      pintarBanda();
      var combo = [src.e.codigo, src.f.codigo, st.metal.codigo].join('|');
      if (combo !== comboAnterior) {
        centrar(carForma.cont, carForma.items[formas.indexOf(f)]);
        centrar(carEstilo.cont, carEstilo.items[estilos.indexOf(e)]);
        comboAnterior = combo;
        cargarGiro();
      }
    }
    actualizar();

    root.anilloCustomizador = { estado: st, mensaje: mensaje, precio: precio };
  }

  function arrancar() {
    document.querySelectorAll('[data-anillo-customizador]').forEach(function (root) {
      if (root.anilloCustomizador) return;
      var s = root.querySelector('script[type="application/json"]');
      if (!s) return;
      try { init(root, JSON.parse(s.textContent)); }
      catch (e) { console.error('Anillo customizador:', e); }
    });
  }

  window.AnilloCustomizador = { init: init, arrancar: arrancar };
  // Arranca ya con los diseñadores que estén arriba de este script (sin esperar al resto de la página)
  // y, por si hay más abajo, otra vez al terminar de cargar.
  arrancar();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  // En el editor de Shopify, volver a armarlo cuando cambian los ajustes.
  document.addEventListener('shopify:section:load', arrancar);
})();
